import { OvertimeRequest } from '../overtime-request';
import {
  IOvertimeRequest,
  IOvertimeRequestData
} from '../overtime-request.types';

export const mockOvertimeRequestsData = (): IOvertimeRequestData[] => [
  {
    id: 1,
    state: 1,
    employee: {
      id: 164,
      first_name: 'Lamar',
      last_name: 'Falconer',
      type: 1,
      hr_department: {
        id: 1,
        name: 'IT - AltoLeap'
      }
    },
    start: '2023-01-09T14:28:00Z',
    end: '2023-01-11T14:28:00Z',
    reason: 'fggfdf',
    approvers: [
      {
        id: 1,
        approver: {
          id: 3,
          first_name: 'Brandon',
          last_name: 'Puim',
          email: 'bpuim@altoleap.com'
        },
        status: 0,
        created_at: '2023-01-09T19:28:53.432285Z',
        updated_at: '2023-01-09T19:28:53.432332Z'
      }
    ],
    attachments: [],
    created_at: '2023-01-09T19:28:53.419541Z',
    updated_at: '2023-01-09T19:28:53.601178Z'
  }
];

export const mockOvertimeRequests = (
  data: IOvertimeRequestData[] = mockOvertimeRequestsData()
): IOvertimeRequest[] => data.map(item => new OvertimeRequest(item));
